import { jsx as r, jsxs as c } from "react/jsx-runtime";
import { Popover as w, Box as l, Typography as f, TextField as Y, IconButton as z } from "@mui/material";
import { u as B } from "../../../chunks/TableContext.js";
import { useState as j, useMemo as H, useCallback as k } from "react";
import { styles as L } from "./styles.js";
import F from "@mui/icons-material/Clear";
import p from "moment-timezone";
const S = p().format("YYYY-MM-DDTHH:mm"), R = (a, m, g) => a ? p(a).tz(g || "UTC").format(m || "MMM DD, YYYY h:mm a z") : "MMM DD, YYYY 00:00 AM/PM", q = ({
  columnId: a,
  anchorEl: m,
  onClose: g
}) => {
  const {
    columnFilters: d,
    setColumnFilters: u,
    data: h,
    getColumnById: I,
    setCurrentPage: x
  } = B(), T = d.find((t) => t.id === a)?.value, o = I(a), [i, b] = j({
    startTime: T?.startTime || "",
    endTime: T?.endTime || ""
  }), {
    minDate: y,
    maxDate: C
  } = H(() => {
    if (!o?.accessorKey && !o?.accessorFn) return {
      minDate: "2020-01-01T00:00",
      maxDate: S
    };
    const t = h.map((e) => {
      const n = o.accessorFn ? o.accessorFn(e, 0) : o.accessorKey ? e[o.accessorKey] : null;
      if (!n || typeof n != "number") return null;
      try {
        const s = String(n).length <= 10 ? n * 1e3 : n;
        return p(s).format("YYYY-MM-DDTHH:mm");
      } catch {
        return null;
      }
    }).filter((e) => e !== null);
    return t.length === 0 ? {
      minDate: "2020-01-01T00:00",
      maxDate: S
    } : {
      minDate: t.reduce((e, n) => p(n).isBefore(p(e)) ? n : e),
      maxDate: t.reduce((e, n) => p(n).isAfter(p(e)) ? n : e)
    };
  }, [h, o]), v = k((t, e) => {
    const n = e ? p(e).format("YYYY-MM-DDTHH:mm") : "", s = {
      ...i,
      [t]: n
    };
    b(s), x(0);
    const M = d.filter((P) => P.id !== a);
    (s.startTime || s.endTime) && M.push({
      id: a,
      value: s
    }), u(M);
  }, [a, d, u, i, x]), D = k((t) => {
    const e = {
      ...i,
      [t]: ""
    };
    b(e), x(0);
    const n = d.filter((s) => s.id !== a);
    (e.startTime || e.endTime) && n.push({
      id: a,
      value: e
    }), u(n);
  }, [a, d, u, i, x]);
  return /* @__PURE__ */ r(w, { open: !!m, anchorEl: m, onClose: g, anchorOrigin: {
    vertical: "bottom",
    horizontal: "right"
  }, transformOrigin: {
    vertical: "top",
    horizontal: "right"
  }, children: /* @__PURE__ */ r(l, { sx: {
    ...L.columnFilterContainer,
    width: "250px",
    padding: "8px",
    backgroundColor: "background.paper"
  }, children: /* @__PURE__ */ c(l, { sx: {
    display: "flex",
    flexDirection: "column",
    gap: "8px"
  }, children: [
    /* @__PURE__ */ c(l, { children: [
      /* @__PURE__ */ r(l, { sx: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "4px"
      }, children: /* @__PURE__ */ r(f, { variant: "caption", sx: {
        fontWeight: 500,
        fontSize: "11px",
        letterSpacing: "0.5px"
      }, children: "Start Date" }) }),
      /* @__PURE__ */ c(l, { sx: {
        display: "flex",
        alignItems: "center",
        flex: 1,
        position: "relative"
      }, children: [
        /* @__PURE__ */ r(Y, { type: "datetime-local", value: i.startTime, onChange: (t) => v("startTime", t.target.value), size: "small", fullWidth: !0, InputLabelProps: {
          shrink: !0
        }, inputProps: {
          min: y,
          max: i.endTime || C,
          onClick: (t) => {
            t.currentTarget.showPicker();
          }
        }, sx: {
          "& .MuiOutlinedInput-root": {
            borderRadius: "6px",
            cursor: "pointer",
            transition: "border-color 0.2s ease",
            backgroundColor: "background.default"
          },
          "& .MuiInputBase-input": {
            padding: "4px 8px",
            fontSize: "13px",
            cursor: "pointer"
          },
          opacity: 0
        } }),
        /* @__PURE__ */ r(f, { variant: "body2", sx: {
          position: "absolute",
          top: 0,
          left: 0,
          pointerEvents: "none",
          height: "100%",
          alignItems: "center",
          display: "flex",
          justifyContent: "flex-start",
          width: "100%",
          color: i.startTime ? "#000000" : "#a2a2a2",
          fontSize: "10px",
          border: "1px solid #c3c3c3",
          borderRadius: "6px",
          paddingLeft: "8px"
        }, children: R(i.startTime, o?.timeFormat, o?.timezone) }),
        /* @__PURE__ */ r(z, { size: "small", onClick: () => D("startTime"), disabled: !i.startTime, sx: {
          padding: "4px",
          "&.Mui-disabled": {
            color: "text.disabled"
          },
          "&:hover": {
            backgroundColor: "action.hover"
          },
          opacity: i.startTime ? 1 : 0,
          marginRight: "6px"
        }, children: /* @__PURE__ */ r(F, { sx: {
          fontSize: "16px"
        } }) })
      ] })
    ] }),
    /* @__PURE__ */ c(l, { children: [
      /* @__PURE__ */ r(l, { sx: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "4px"
      }, children: /* @__PURE__ */ r(f, { variant: "caption", sx: {
        fontWeight: 500,
        fontSize: "11px",
        letterSpacing: "0.5px"
      }, children: "End Date" }) }),
      /* @__PURE__ */ c(l, { sx: {
        flex: 1,
        position: "relative",
        display: "flex",
        alignItems: "center"
      }, children: [
        /* @__PURE__ */ r(Y, { type: "datetime-local", value: i.endTime, onChange: (t) => v("endTime", t.target.value), size: "small", fullWidth: !0, InputLabelProps: {
          shrink: !0
        }, inputProps: {
          min: i.startTime || y,
          max: C,
          onClick: (t) => {
            t.currentTarget.showPicker();
          }
        }, sx: {
          "& .MuiOutlinedInput-root": {
            borderRadius: "6px",
            cursor: "pointer",
            transition: "border-color 0.2s ease",
            backgroundColor: "background.default"
          },
          "& .MuiInputBase-input": {
            padding: "4px 8px",
            fontSize: "13px",
            cursor: "pointer"
          },
          opacity: 0
        } }),
        /* @__PURE__ */ r(f, { variant: "body2", sx: {
          position: "absolute",
          top: 0,
          left: 0,
          pointerEvents: "none",
          height: "100%",
          alignItems: "center",
          display: "flex",
          justifyContent: "flex-start",
          width: "100%",
          color: i.endTime ? "#000000" : "#a2a2a2",
          fontSize: "10px",
          border: "1px solid #c3c3c3",
          borderRadius: "6px",
          paddingLeft: "8px"
        }, children: R(i.endTime, o?.timeFormat, o?.timezone) }),
        /* @__PURE__ */ r(z, { size: "small", onClick: () => D("endTime"), disabled: !i.endTime, sx: {
          padding: "4px",
          "&.Mui-disabled": {
            color: "text.disabled"
          },
          "&:hover": {
            backgroundColor: "action.hover"
          },
          opacity: i.endTime ? 1 : 0,
          marginRight: "6px"
        }, children: /* @__PURE__ */ r(F, { sx: {
          fontSize: "16px"
        } }) })
      ] })
    ] })
  ] }) }) });
};
export {
  q as default
};
